import { RootState } from '../reducers'

export const getIsLoading = (state: RootState) => state.servicePrincipal.isLoading
export const getIsConfirmLoading = (state: RootState) =>
  state.servicePrincipal.isConfirmLoading
export const getIsDetailLoading = (state: RootState) =>
  state.servicePrincipal.isDetailLoading
export const getIsRoleActionLoading = (state: RootState) =>
  state.servicePrincipal.isRoleActionLoading
export const getServicePrincipals = (state: RootState) =>
  state.servicePrincipal.servicePrincipals
export const getServicePrincipalSelected = (state: RootState) =>
  state.servicePrincipal.servicePrincipalSelected
export const getServicePrincipalDetail = (state: RootState) =>
  state.servicePrincipal.servicePrincipalDetail
export const getPageMeta = (state: RootState) => state.servicePrincipal.pageMeta
export const getCurrentStatus = (state: RootState) =>
  state.servicePrincipal.currentStatus
export const getModalVisibility = (name: string) => (state: RootState) =>
  state.servicePrincipal.modalVisibility[name]?.visible || false
export const getServicePrincipalRoles =
  (servicePrincipalId: string) => (state: RootState) =>
    state.servicePrincipal.rolesByServicePrincipal[servicePrincipalId]
export const getIsLoadingServicePrincipalRoles =
  (servicePrincipalId: string) => (state: RootState) =>
    state.servicePrincipal.loadingRolesByServicePrincipal[servicePrincipalId] ||
    false
